import { Box, Typography } from '@mui/material'
import React from 'react'
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox'
import DraftsOutlinedIcon from '@mui/icons-material/DraftsOutlined'
import { useNavigate } from 'react-router-dom'

const NotificationSettings = () => {
  const navigate = useNavigate()

  const notificationSettings = [
    {
      id: 1,
      title: 'Custom Notification Templates',
      subTitle: 'Create and customize your own notification templates.',
      icon: <DraftsOutlinedIcon fontSize="large" color="secondary" />,
      path: '/admin/custom-notification-templates',
    },
    {
      id: 2,
      title: 'Email Redirection',
      subTitle: 'Redirect emails to an alternate recipient.',
      icon: <ForwardToInboxIcon fontSize="large" color="primary" />,
      path: '/admin/email-redirection',
    },
  ]

  return (
    <Box mt={2}>
      <Box style={{ display: 'flex', gap: 16, marginBottom: '2rem' }}>
        <Typography variant="h5" fontWeight="bold">
          Notification Settings
        </Typography>
      </Box>
      <Box style={{ display: 'flex', rowGap: '3rem', columnGap: '1rem', flexWrap: 'wrap' }}>
        {notificationSettings.map((setting) => (
          <Box
            key={setting.id}
            onClick={() => {
              navigate(setting.path)
            }}
            sx={{
              flexBasis: 'calc(33% - 16px)',
              display: 'flex',
              cursor: 'pointer',
              columnGap: '1rem',
              alignItems: 'center',
            }}
          >
            <div>{setting.icon}</div>
            <div>
              <Typography variant="subtitle1" fontWeight="bold">
                {setting.title}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {setting.subTitle}
              </Typography>
            </div>
          </Box>
        ))}
      </Box>
    </Box>
  )
}

export default NotificationSettings
